import type { MbcBriefAssetTarget } from "@nlc/shared-types";
import type { LucideIcon } from "lucide-react";

import {
  FileText,
  Globe,
  Heart,
  Image,
  Megaphone,
  Palette,
  Shapes,
  Type,
} from "lucide-react";

type AssetCopy = {
  dropzoneTitle: string;
  examples: { icon: LucideIcon; label: string }[];
  linkPlaceholder: string;
  /** Names the target in "<N> items in <scope>". */
  scope: string;
};

export const ASSET_COPY: Record<MbcBriefAssetTarget, AssetCopy> = {
  assets: {
    dropzoneTitle: "Drop the files to use in your design",
    examples: [
      { icon: Shapes, label: "Logos" },
      { icon: Image, label: "Product photos" },
      { icon: Type, label: "Fonts" },
      { icon: FileText, label: "Copy docs" },
    ],
    linkPlaceholder: "Google Drive or Dropbox folder",
    scope: "assets",
  },
  inspirations: {
    dropzoneTitle: "Drop examples of the style you want",
    examples: [
      { icon: Megaphone, label: "Ads you like" },
      { icon: Heart, label: "Social posts" },
      { icon: Globe, label: "Websites" },
      { icon: Palette, label: "Color palettes" },
    ],
    linkPlaceholder: "Pinterest board, Behance, or any web page",
    scope: "inspiration",
  },
};
